import React from "react";
import "../styles/SubsidyOver.scss";
import InfoIcon from "../img/svg/info_blue.svg";
import { useTranslation } from "react-i18next";

const SubsidyOver = () => {
  const { t } = useTranslation();
  
  return (
    <div className="subsidy-over-container">
      <img src={InfoIcon} alt="info" />
      <p className="subsidy-text">{t("SUBSIDY_OVER_MESSAGE")}</p>
    </div>
  );
};

export default SubsidyOver;
